import { Injectable } from '@angular/core';
import { gql } from '@apollo/client/core';
import { Query } from 'apollo-angular';

export interface ProductsSkuResponse {
  productSKUByColor: ProductSku[];
}

export interface ProductSku {
  baseMaterialNumber: string;
  tinting: {
    sku: string;
  };
}

export interface ProductsSkuQueryVariables {
  languageCode: string;
  productSkuSearch: {
    colorCode: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class ProductsSkuQuery extends Query<ProductsSkuResponse, ProductsSkuQueryVariables> {
  override document = gql`
    query productSKUByColor($languageCode: NonEmptyString!, $productSkuSearch: ProductSkuSearchInput!) {
      productSKUByColor(languageCode: $languageCode, productSkuSearch: $productSkuSearch) {
        baseMaterialNumber
        tinting {
          sku
        }
      }
    }
  `;
}
